import React, { useContext, useState } from "react";

import PsContext from "../../../context";
import { cdnFileLink } from "../../../utils";
const SliderImage = ({ item }) => {
  const context = useContext(PsContext);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  const handleImageLoad = (event) => {
    const { naturalWidth, naturalHeight } = event.target;
    setDimensions({ width: naturalWidth, height: naturalHeight });
  };
  return (
    <div>
      <img
        className="d-block ms-auto me-auto w-100"
        src={cdnFileLink(item.feature_image)}
        onLoad={handleImageLoad}
        style={{ top: dimensions.height > 900 ? "-20%" : "0" }}
        alt="First slide"
      />
    </div>
  );
};

export default SliderImage;
